import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import calendars from 'scoreboard/components/calendars'
import template from './metric-frequency-new.hbs'
import SelectReportStacksForm from '../common/select-report-stacks-form'
import calendarItem from './metric-frequency-calendar-item.hbs'

var MetricFrequencyNew = Backbone.View.extend({

	className: 'reports metric-frequency margin-collapse',

	events: {
		'change input[name=frequencies]' : 'toggleFrequencies'
	},

	initialize: function(options) {
		_.set(this.model.attributes, 'filters.nativeCalendarIds[0].values', [])
		this.filters = this.model.get('filters')
		this.stacksForm = new SelectReportStacksForm(_.pick(this, ['el', 'model']))
	},

	render: function() {
		const allColumns =
			_.flatMap(this.model.stacks().models, it => it.columns().models)
		const showId =
			!!allColumns.find(it => it.get('columnType') === 'id')
		const showLabel =
			!!allColumns.find(it => it.get('columnType') === 'label')
		var html = $(template({
			showId, showLabel
		}))
		var calendarOpts = html.find('.calendar-options')
		_.each(calendars.calendars, function(cal) {
			calendarOpts.append(calendarItem(cal))
		})
		this.$el.html(html)

		this.stacksForm.render()

		var selected = _.keyBy(this.filters.nativeCalendarIds[0].values)
		this.$('input[name=frequencies]').each(function() {
			var cb = $(this)
			cb.prop('checked', !_.isUndefined(selected[cb.val()]))
		})

		return this
	},

	toggleFrequencies: function(e) {
		var nci = this.filters.nativeCalendarIds[0]
		nci.metadata = nci.metadata || {}
		var cb = this.$(e.target)
		let calId = parseInt(cb.val())
		if (cb.is(':checked')) {
			nci.values.push(calId)
			nci.metadata[cb.val()] = {label:cb.data('label')}
		} else {
			_.pull(nci.values, calId)
			delete nci.metadata[cb.val()]
		}
		this.model.trigger('change')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.stacksForm], 'remove')
	}

})

export default MetricFrequencyNew

MetricFrequencyNew.__filename__ = 'reports/wizard/metric-frequency/metric-frequency-new.js'
